<template>
    <el-dialog :visible.sync="show" width="30%" :before-close="closeDialog" :close-on-click-modal="false">
        <el-form>

            <el-form-item label="现有数量:" label-width='120px'>
                {{ balance }}
            </el-form-item>

            <el-form-item label="修改数量:" label-width='120px'>
                <el-input style="width: 200px" v-model="submit_data.amount"></el-input>
            </el-form-item>

            <el-form-item label="操作方式:" label-width='120px'>
                <el-radio-group v-model="submit_data.mode">
                    <el-radio-button label="sub">减少</el-radio-button>
                    <!--                    <el-radio-button label="add">增加</el-radio-button>-->
                </el-radio-group>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="onSubmit">确 定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    var _this;
    export default {
        props: {
            'isShow': Boolean,
            'data': ''
        },
        watch: {

            isShow(newData, oldData) {

                _this.show = true;
                _this.submit_data.consumer_code = _this.data;


                _this.getDetails()


            }
        },
        data() {
            return {


                show: false,

                balance:'',


                // 表单数据
                submit_data: {
                    consumer_code: '',
                    operation: 'balance',
                    amount:'',
                    mode:'sub'
                },



            };
        },
        created() {

            _this = this;

        },
        methods: {
            // 获取余额
            getDetails(){

                this.$post(
                    '/consumer/getConsumerCoinWalletDetails', {
                        consumer_code: this.submit_data.consumer_code
                    }
                ).then(res => {

                    _this.balance = res.data.balance

                });
            },

            // 关闭方法
            closeDialog() {
                _this.show = false;

                _this.submit_data = {
                    consumer_code: '',
                    operation: 'balance',
                    amount:'',
                    mode:'sub'
                }

            },
            // 提交
            onSubmit() {
                _this.$post(
                    '/consumer/editCoinWallet',
                    _this.submit_data
                )
                    .then(res => {

                        _this.closeDialog();

                        _this.$message.success({
                            message: res.msg,
                            duration: 1500
                        });

                    }).catch(res => {

                });
            }

        }
    };
</script>

<style scoped>
    .form-box {
        padding: 20px;
        box-sizing: border-box;
        margin-right: 0;
        width: 100%;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .el-form-second {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .avatar-uploader {
        width: 100px;
        height: 100px;
    }
</style>